import type { ReactNode } from 'react';

export enum CommonPaymentBoxMode {
  ADD = 'ADD',
  DROP = 'DROP',
}
export type CommonPaymentBoxProps = {
  subtotal: number;
  fees: number;
  total: number;
  slug: string;
  signedPrice: string;
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  mode: CommonPaymentBoxMode;
  commonCardSummaryNode: ReactNode;
  attachCardsToUserCollections?: boolean;
};
